import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const WelcomeModal = ({ isOpen, onClose, title, icon, children }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ duration: 0.3 }}
            className="bg-white rounded-2xl p-8 max-w-lg w-full shadow-2xl"
          >
            <div className="text-center mb-6">
              {icon && <div className="text-6xl mb-4">{icon}</div>}
              <h2 className="text-3xl font-bold text-charcoal-800 mb-2">
                Welcome to {title}!
              </h2>
            </div>

            <div className="text-charcoal-700 leading-relaxed mb-8">
              {children}
            </div>

            <button
              onClick={onClose}
              className="w-full bg-gradient-to-r from-teal-600 to-emerald-600 text-white py-3 px-6 rounded-xl hover:from-teal-700 hover:to-emerald-700 transition-all font-semibold shadow-md hover:shadow-lg"
            >
              Got it, let's go!
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default WelcomeModal;
